import { hasStylesToRemove } from "@azu-business/editor-v3";
import { AitTableData } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";
import { hasStylesInRowGroup } from "./hasStylesInRowGroup";

/**
 * Checks if table data contains any Optional or Notes styles.
 * Checks header group, body row groups, and table comments.
 *
 * @template T - Content type for table cells and comments
 * @param tableData - The table data to check for styles
 * @returns True if any styles to remove are found, false otherwise
 */
export const hasStylesInTableData = <T>(tableData: AitTableData<T>): boolean => {
  const stylesToCheck = [...STYLES_TO_DELETE, ...STYLES_TO_CLEAN];

  // Check table comments
  if (hasStylesToRemove(tableData.comments, stylesToCheck)) {
    return true;
  }

  // Check header data if it exists
  if (tableData.headerData && hasStylesInRowGroup(tableData.headerData)) {
    return true;
  }

  // Check body data row groups
  return tableData.bodyData.some((rowGroup) => hasStylesInRowGroup(rowGroup));
};
